let API_BASE = "/api";
export class RelatedContentConstants {
  public static API_RELATED_CONTENT = API_BASE + "/related/content";
  public static API_RELATED_EXPERTS = API_BASE + "/related/experts";
}
